import { combineReducers } from '@reduxjs/toolkit'
import undoable from 'redux-undo'
import entitiesReducer from 'apps/formsCreationKit/store/reducers/entities'
import liveDataReducer from 'apps/formsCreationKit/store/reducers/liveDataSources'
import dataSourceContextReducer from 'apps/formsCreationKit/store/reducers/dataSourceContexts'
import {
  appSettingsReducer,
  clientSettingsReducer,
  whiteLabelSettingsReducer,
  workspaceConfigSettingsReducer,
} from 'apps/formsCreationKit/store/reducers/settings'
import { featureFlagsReducer } from 'apps/formsCreationKit/store/reducers/featureFlags'
import { importDataReducer } from 'apps/formsCreationKit/store/reducers/importData'
import typesReducer from 'apps/formsCreationKit/store/reducers/types'
import referenceDataReducer from 'apps/formsCreationKit/store/reducers/referenceData'
import referenceImagesReducer from 'apps/formsCreationKit/store/reducers/referenceImages'
import { reducers } from '@gocanvas/client'
const { clientEntries: clientEntriesReducer, clientContextParams } = reducers

const featureCheck = featureName => {
  const { initialOnboardingState = {} } = window
  const { feature_flags = {} } = initialOnboardingState
  return feature_flags[featureName]
}

export const builderReducers = {
  entities: undoable(entitiesReducer, { ignoreInitialState: true }),
  types: typesReducer,
  settings: appSettingsReducer,
  whiteLabelSettings: whiteLabelSettingsReducer,
  clientEntries: clientEntriesReducer,
  clientContextParams,
  clientSettings: clientSettingsReducer,
  workspaceConfig: workspaceConfigSettingsReducer,
  featureFlags: featureFlagsReducer,
  referenceData: referenceDataReducer,
  referenceImages: referenceImagesReducer,
  liveDataSources: liveDataReducer,
  dataSourceContexts: dataSourceContextReducer,
}

if (featureCheck('import_form')) {
  builderReducers.importData = importDataReducer
}

const rootReducer = combineReducers(builderReducers)

export default rootReducer
